<main class="dialogContainer">
  <section class="dialogHeader">
    <h2 mat-dialog-title>{{ uploadFileDialogData.title }}</h2>
    <p [ngClass]="{ requestedChange: hasRequestedChange() }">
      {{ uploadFileDialogData.requestedChange || uploadFileDialogData.message }}
    </p>
  </section>
  <section class="totalAllocation">
    <p>Total Allocation</p>
    <p>{{ uploadFileDialogData.totalAllocation | customCurrency }}</p>
  </section>

  <mat-dialog-content class="dialogContent">
    @for (expense of uploadFileDialogData.expenseCategories; track expense) {
      <section class="dialogFields">
        <p>{{ expense.category | titlecase }}</p>
        <p>{{ expense.amount | customCurrency }}</p>
        @if (!expense.isUploaded) {
          <button mat-flat-button color="primary" (click)="uploadFile(expense)">
            Upload {{ uploadFileDialogData.currentStep.toLocaleLowerCase() }}
          </button>
        }
        @if (expense.isUploaded) {
          <button mat-flat-button color="accent" (click)="viewFile(expense)">
            View {{ uploadFileDialogData.currentStep.toLocaleLowerCase() }}
          </button>
        }
      </section>
    }
    <mat-divider></mat-divider>
  </mat-dialog-content>
  <mat-dialog-actions class="matDialogActions">
    <button
      mat-flat-button
      color="accent"
      class="matDialogCancelButton"
      (click)="closeDialog()"
    >
      Cancel
    </button>
    <section class="dialogButtons">
      @if (!isFirstApprover) {
        <button
          mat-flat-button
          color="accent"
          [disabled]="!hasFiles()"
          (click)="RequestChanges()"
        >
          Send back for changes
        </button>
      }
      @if (isFirstApprover) {
        <button
          mat-flat-button
          color="primary"
          [disabled]="enableSaveForLater()"
          class="matDialogActionButton"
          (click)="onSubmit(true)"
        >
          Save for later
        </button>
      }
      <button
        mat-flat-button
        color="primary"
        [disabled]="enableSubmit()"
        class="matDialogActionButton"
        (click)="onSubmit(false)"
      >
        {{ uploadFileDialogData.buttonLabel }}
      </button>
    </section>
  </mat-dialog-actions>
</main>
